module.exports = __webpack_public_path__ + "static/media/생.6400d2d8.jpg";